document.addEventListener('DOMContentLoaded', function () {
    var domain = window.location.hostname.split('.').pop();
    var currencySymbol;
    if (domain === 'co.uk') {
        currencySymbol = '£';
    } else if (domain === 'com') {
        currencySymbol = '$';
    } else if (domain === 'eu') {
        currencySymbol = '€';
    } else {
        currencySymbol = '£';
    }

    const FREE_DELIVERY_THRESHOLD = 25; // Set the free delivery threshold

    var modal = document.createElement('div');
    modal.id = 'bb-modal';

    var modalContent = document.createElement('div');
    modalContent.id = 'bb-modal-content';
    modalContent.className = 'bb-modal-content';

    var modalHeader = document.createElement('div');
    modalHeader.className = 'mod-sum-header';

    var headerTitle = document.createElement('div');
    headerTitle.className = 'mod-header-title';
    headerTitle.textContent = 'Summary';

    var modalClose = document.createElement('span');
    modalClose.id = 'bb-modal-close';
    modalClose.className = 'bb-modal-close';
    modalClose.textContent = '×';
    modalClose.setAttribute('aria-label', 'Close modal');

    modalHeader.appendChild(headerTitle);
    modalHeader.appendChild(modalClose);

    var modalBody = document.createElement('div');
    modalBody.id = 'bb-modal-body';
    modalBody.className = 'bb-modal-body';

    modalContent.appendChild(modalHeader);
    modalContent.appendChild(modalBody);
    modal.appendChild(modalContent);
    document.body.appendChild(modal);

    function createProductLineItem(productId, productName, productPrice, quantity) {
        var productLine = document.createElement('div');
        productLine.className = 'bb-modal-product-line';
        productLine.setAttribute('data-price', productPrice);
        productLine.setAttribute('data-variant-id', productId);

        var detailsDiv = document.createElement('div');
        detailsDiv.className = 'bb-mod-details';

        var nameDiv = document.createElement('div');
        nameDiv.textContent = productName;
        nameDiv.className = 'bb-mod-name';
        detailsDiv.appendChild(nameDiv);

        var quantityDiv = document.createElement('div');
        quantityDiv.className = 'bb-mod-quantity';

        var quantityLabel = document.createElement('label');
        quantityLabel.textContent = 'Quantity: ';
        quantityLabel.setAttribute('for', 'quantity-select-' + productId);
        quantityDiv.appendChild(quantityLabel);

        var quantitySelect = document.createElement('select');
        quantitySelect.className = 'bb-modal-quantity-select';
        quantitySelect.id = 'quantity-select-' + productId;
        quantitySelect.setAttribute('data-variant-id', productId);
        quantitySelect.setAttribute('aria-label', 'Quantity for ' + productName);

        for (var i = 1; i <= 10; i++) {
            var option = document.createElement('option');
            option.value = i;
            option.textContent = i;
            if (i == quantity) {
                option.selected = true;
            }
            quantitySelect.appendChild(option);
        }

        quantityDiv.appendChild(quantitySelect);
        detailsDiv.appendChild(quantityDiv);
        productLine.appendChild(detailsDiv);

        var endWrap = document.createElement('div');
        endWrap.className = 'bb-modal-end-wrap';

        var priceSpan = document.createElement('span');
        priceSpan.textContent = `${currencySymbol}${(quantity * productPrice).toFixed(2)}`;
        priceSpan.className = 'bb-mod-price';
        endWrap.appendChild(priceSpan);

        var removeButton = document.createElement('button');
        removeButton.className = 'bb-modal-remove';
        removeButton.textContent = 'Remove';
        removeButton.onclick = function () {
            removeProductLine(productId);
        };
        endWrap.appendChild(removeButton);

        productLine.appendChild(endWrap);

        return productLine;
    }

    function calculateTotalValue() {
        var totalValue = 0;

        document.querySelectorAll('.bb-modal-body .bb-modal-product-line').forEach(function (productLine) {
            var price = parseFloat(productLine.getAttribute('data-price'));
            var quantitySelect = productLine.querySelector('.bb-modal-quantity-select');
            var quantity = parseInt(quantitySelect.value) || 0;
            totalValue += price * quantity;
        });

        return totalValue.toFixed(2);
    }

    function updateDeliveryMessage(totalValue) {
        var deliveryMessageElement = document.querySelector('.mod-last-del');
        if (deliveryMessageElement) {
            if (totalValue < FREE_DELIVERY_THRESHOLD) {
                var remainingForFreeDelivery = (FREE_DELIVERY_THRESHOLD - totalValue).toFixed(2);
                deliveryMessageElement.textContent = `spend ${currencySymbol}${remainingForFreeDelivery} more for free delivery`;
            } else {
                deliveryMessageElement.textContent = 'with free, fast delivery';
            }
        }
    }

    function updateTotals() {
        var totalQuantity = 0;

        document.querySelectorAll('.bundle-builder .product-item').forEach(function (item) {
            var quantity = parseInt(item.querySelector('input[name="quantity"]').value) || 0;
            totalQuantity += quantity;
        });

        document.getElementById('total-quantity').innerText = totalQuantity;
        var totalValue = calculateTotalValue();
        document.getElementById('total-value').innerText = `${currencySymbol}${totalValue}`;
        
        // Update the total in the modal summary
        var modalTotalElement = document.querySelector('.mod-last-summary h5');
        if (modalTotalElement) {
            modalTotalElement.textContent = `Total: ${currencySymbol}${totalValue}`;
        }

        // Update the delivery message
        updateDeliveryMessage(parseFloat(totalValue));
    }

    function updateModalContent() {
        var modalBody = document.getElementById('bb-modal-body');
        while (modalBody.firstChild) {
            modalBody.removeChild(modalBody.firstChild);
        }

        document.querySelectorAll('.bundle-builder .product-item').forEach(function (item) {
            var quantity = parseInt(item.querySelector('input[name="quantity"]').value);
            if (quantity > 0) {
                var productId = item.getAttribute('data-variant-id');
                var productName = item.querySelector('.variant-name').textContent;
                var productPrice = parseFloat(item.getAttribute('data-price'));

                var productLine = createProductLineItem(productId, productName, productPrice, quantity);
                modalBody.appendChild(productLine);
            }
        });

        // Add the new summary div
        var summaryDiv = document.createElement('div');
        summaryDiv.className = 'mod-last-summary';

        var totalHeader = document.createElement('h5');
        totalHeader.textContent = `Total: ${currencySymbol}${calculateTotalValue()}`;
        summaryDiv.appendChild(totalHeader);

        var deliveryInfo = document.createElement('p');
        deliveryInfo.className = 'mod-last-del';
        summaryDiv.appendChild(deliveryInfo);

        var continueButton = document.createElement('button');
        continueButton.id = 'mod-last-continue';
        continueButton.textContent = 'Add to Cart';
        continueButton.onclick = function() {
            document.getElementById('bb-continue').click();
            closeModal();
        };
        summaryDiv.appendChild(continueButton);

        var continueShoppingText = document.createElement('p');
        continueShoppingText.id = 'mod-last-cont';
        continueShoppingText.textContent = 'continue shopping';
        continueShoppingText.onclick = closeModal;
        summaryDiv.appendChild(continueShoppingText);

        modalBody.appendChild(summaryDiv);

        updateTotals();
    }

    function adjustQuantity(productId, newValue) {
        var quantitySelectModal = document.querySelector('.bb-modal-quantity-select[data-variant-id="' + productId + '"]');
        var quantityInputMainPage = document.querySelector('.bundle-builder .product-item[data-variant-id="' + productId + '"] input[name="quantity"]');
        var priceSpan = document.querySelector('.bb-modal-product-line[data-variant-id="' + productId + '"] .bb-mod-price');
        var currentPrice = parseFloat(document.querySelector('.bundle-builder .product-item[data-variant-id="' + productId + '"]').getAttribute('data-price'));

        if (quantitySelectModal && quantityInputMainPage && priceSpan) {
            if (newValue >= 1 && newValue <= 10) {
                quantitySelectModal.value = newValue;
                quantityInputMainPage.value = newValue;
                priceSpan.textContent = `${currencySymbol}${(newValue * currentPrice).toFixed(2)}`;
                updateTotals();
            }

            checkForEmptyModal();
        }
    }

    function removeProductLine(productId) {
        var productLineModal = document.querySelector('.bb-modal-product-line[data-variant-id="' + productId + '"]');
        var productItemMainPage = document.querySelector('.bundle-builder .product-item[data-variant-id="' + productId + '"]');

        if (productLineModal && productItemMainPage) {
            productLineModal.remove();
            productItemMainPage.querySelector('input[name="quantity"]').value = 0;
            updateTotals();
            checkForEmptyModal();
        }
    }

    function checkForEmptyModal() {
        if (document.querySelectorAll('.bb-modal-body .bb-modal-product-line').length === 0) {
            closeModal();
        }
    }

    function openModal() {
        updateModalContent();
        modal.style.display = 'block';
    }

    function closeModal() {
        modal.style.display = 'none';
    }

    // Add event listener for bb-sum-button
    document.getElementById('bb-sum-button').addEventListener('click', openModal);

    // Add event listeners for all elements with class 'sum-one'
    document.querySelectorAll('.sum-one').forEach(function(element) {
        element.addEventListener('click', openModal);
    });

    modalClose.addEventListener('click', closeModal);

    window.addEventListener('click', function (event) {
        if (event.target == modal) {
            closeModal();
        }
    });

    modalBody.addEventListener('change', function (event) {
        if (event.target.classList.contains('bb-modal-quantity-select')) {
            var productId = event.target.getAttribute('data-variant-id');
            var newValue = parseInt(event.target.value) || 1;
            adjustQuantity(productId, newValue);
        }
    });
});